export interface IManagingCompanyInfo {
  companyNameUk: string;
  companyNameEn: string;
  companyNameRu: string;
  addressUk: string;
  addressEn: string;
  addressRu: string;
  webSite: string;
  emailOffice: string;
  emailSupport: string;
  phone1: string;
  phone2: string;
  phoneSupport: string;
  fax: string;
  telegram: string;
  viber: string;
  youtube: string;
  facebook: string;
  instagram: string;
  linkedin: string;
  landing: string;
}

export class IitCloudProviderSettings {
  id: string = '';
  enabled: boolean = false;
  name: string = '';
  nameEn: string = '';
  ksp: number = 0;
  address: string = '';
  port: string | null = null;
  directAccess: boolean = false;
  clientIdPrefix: string | null = null;
  confirmationUrl: string | null = null;
  mobileAppName: string | null = null;

  constructor(sett: any) {
    if (sett) {
      this.id = sett.id;
      this.enabled = sett.enabled;
      this.name = sett.name;
      this.nameEn = sett.nameEn;
      this.ksp = sett.ksp;
      this.address = sett.address;
      this.port = 'port' in sett ? sett.port : null;
      this.directAccess = sett.directAccess;
      this.clientIdPrefix = 'clientIdPrefix' in sett ? sett.clientIdPrefix : null;
      this.confirmationUrl = 'confirmationUrl' in sett ? sett.confirmationUrl : null;
      this.mobileAppName = 'mobileAppName' in sett ? sett.mobileAppName : null;
    }
  }

  get isSigningWithQr(): boolean { return !!this.confirmationUrl; }
}
